import React from 'react';
import PropTypes from 'prop-types';
import CartContainer from '../../ShoppingCart/CartContainer/CartContainer';

export default function ShoppingCartPage({
  create_user_endpoint,
  create_account_endpoint,
  create_property_endpoint,
  create_property_ownership_endpoint,
  create_power_of_attorney_endpoint,
  create_business_license_survey_endpoint,
  create_subscription_endpoint,
  create_payment_account_endpoint
}) {
  return (
    <div>
      <CartContainer
        create_user_endpoint={create_user_endpoint}
        create_account_endpoint={create_account_endpoint}
        create_property_endpoint={create_property_endpoint}
        create_property_ownership_endpoint={create_property_ownership_endpoint}
        create_power_of_attorney_endpoint={create_power_of_attorney_endpoint}
        create_business_license_survey_endpoint={create_business_license_survey_endpoint}
        create_subscription_endpoint={create_subscription_endpoint}
        create_payment_account_endpoint={create_payment_account_endpoint}
      />
    </div>
  );
}

ShoppingCartPage.propTypes = {
  create_user_endpoint: PropTypes.string.isRequired,
  create_account_endpoint: PropTypes.string.isRequired,
  create_property_endpoint: PropTypes.string.isRequired,
  create_property_ownership_endpoint: PropTypes.string.isRequired,
  create_power_of_attorney_endpoint: PropTypes.string.isRequired,
  create_business_license_survey_endpoint: PropTypes.string.isRequired,
  create_subscription_endpoint: PropTypes.string.isRequired,
  create_payment_account_endpoint: PropTypes.string.isRequired
};
